<template>
  <div class="h-full" data-theme="main" :class="{ 'app-': modalWalletRequired?.isBlocked }">
    <router-view :isBlocked="modalWalletRequired?.isBlocked"/>
    <modalMandatoryFields v-if="!modalPrivacyVisible"/>
    <modalLocalStorageUnavailable/>
    <modalMigrationWallet v-if="!modalPrivacyVisible && userDomainInfo"/>
    <modalPrivacyPolicy v-if="modalPrivacyVisible" />
  </div>
  <modalMemberRequirements v-if="loggedInUser" ref="modalWalletRequired" />
</template>

<script setup>
import './assets/styles/styles.less';
import './assets/styles/extra.less';
import { useRouter } from 'vue-router';
import 'element-plus/theme-chalk/index.css';
import modalMandatoryFields from '@/core/components/modalMandatoryFields.vue';
import modalLocalStorageUnavailable from '@/core/components/modalLocalStorageUnavailable.vue';
import modalMigrationWallet from '@/core/components/modalMigrationWallet.vue';
import modalPrivacyPolicy from '@/core/components/modalPrivacyPolicy.vue';
import modalMemberRequirements from '@/core/components/modalMemberRequirements.vue';
import { computed, useTemplateRef } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const userDomainInfo = computed(() => store.state.user.userDomainInfo);
const loggedInUser = computed(() => store.getters['user/loggedInUser']);
const modalPrivacyVisible = computed(() => {
  return loggedInUser.value && userDomainInfo.value && !userDomainInfo.value.privacyPolicy;
});
const modalWalletRequired = useTemplateRef('modalWalletRequired');
const router = useRouter();
router.beforeEach((to, from, next) => {
  if (modalWalletRequired.value && modalWalletRequired.value.isBlocked) {
    window.location.reload();
  } else next();
});
</script>
<style>
.app- {
  pointer-events: none;
  opacity: 0.5;
}
</style>